import { action } from "mobx";
import { BaseEditViewStore } from "core/stores";
import { NikoPatientDetailService } from "application/niko-patient/services";
import { NikoPatientInsuranceInfoNoteModalForm } from 'application/niko-patient/forms';

class NikoPatientInsuranceInfoNoteModalStore extends BaseEditViewStore {
	constructor(rootStore, componentProps) {
        const nikoPatientDetail = componentProps.modalParams.data.nikoPatientDetail;
        const nikoPatientDetailService = new NikoPatientDetailService(rootStore.application.baasic.apiClient);
        super(rootStore, {
			name: 'niko-patient-insurance-info-note-modal',
			Form: NikoPatientInsuranceInfoNoteModalForm,
			id: nikoPatientDetail.id,
			actions: () => {
				return {
					get: async () => {
						return nikoPatientDetail;
					},
					update: async () => {
						await nikoPatientDetailService.updatePatientInsuranceInfo(this.nikoPatientDetail);
					}
				}
			},
			FormClass: NikoPatientInsuranceInfoNoteModalForm
		});

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.nikoPatientDetail = nikoPatientDetail;
        this.setTempValue = this.modalParams.data.setTempValue;
    }

	@action.bound
	async updateResource(resource) {
		if (!this.actions.update) return;

		this.form.setFieldsDisabled(true);
		try {
			if (this.translationStore) {
				this.translationStore.applyMetadata(resource);
			}

			this.nikoPatientDetail.insuranceInfoNote = this.form.$("insuranceInfoNote").value;
			if(this.setTempValue){
				this.setTempValue(this.nikoPatientDetail);
			}

			await this.actions.update();
			this.modalParams.close();
		}
		catch (err) {
			this.form.setFieldsDisabled(false);
			return this.onUpdateError(err);
		}
	}
}

export default NikoPatientInsuranceInfoNoteModalStore;